import React, {Fragment} from 'react';
import PropTypes from 'prop-types';
import {withNotificationsHubAuthFlow} from '@cimpress-technology/react-notifications-hub';
import {Button} from '@cimpress/react-components';
import { getSubscriptions, deleteSubscription, postSubscription } from './client/subscriptions';
import { getCanonicalIdFromJWT } from './common';

class SubscriptionButton extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            isUserSubscribed: undefined,
            subscriptionsForUser: undefined
        }
        this.onClick = this.onClick.bind(this);
        this.init = this.init.bind(this);
    }

    componentDidMount() {
        this.init();
    }

    init() {
        if (this.props.resourceFilter){
            getSubscriptions({resourceType: this.props.resourceType, resourceId: this.props.resourceUrl, filter: this.props.resourceFilter}, this.props.accessToken,this.props.environment).then((subscriptionForUser) =>{
                if (subscriptionForUser) {
                    this.setState({isUserSubscribed: true, subscriptionsForUser: subscriptionForUser});
                } else {
                    this.setState({isUserSubscribed: undefined, subscriptionsForUser: undefined});
                }
    
            });
        }
        else{
            const user = getCanonicalIdFromJWT(this.props.accessToken);
            getSubscriptions({resourceType: this.props.resourceType, resourceId: this.props.resourceUrl}, this.props.accessToken,this.props.environment).then((rawSubscriptions) =>{
                const subscriptionForUser = rawSubscriptions.find((sub) => sub.subscriber === user);
                if (subscriptionForUser) {
                    this.setState({isUserSubscribed: true, subscriptionsForUser: subscriptionForUser});
                } else {
                    this.setState({isUserSubscribed: undefined, subscriptionsForUser: undefined});
                }
            });
    }
}

    onClick() {
        try {
            this.props.ensureAuthorized().then((res) => {
                if (res.isAuthorized) {
                    if(this.state.isUserSubscribed){
                        deleteSubscription(this.state.subscriptionsForUser.id, this.props.accessToken, this.props.environment)
                        .then(() => this.setState({isUserSubscribed: false, subscriptionsForUser: undefined}));
                    }
                    else{
                    postSubscription(this.props.subscriptionToAdd, this.props.accessToken, this.props.environment)
                    .then((sub) => this.setState({isUserSubscribed: true, subscriptionsForUser: sub}));
                }
                }
            });
        } catch (error) {
            // if they hit cancel, promise is rejected and we do nothing
        }
    }


    render() {
        return (
            <Fragment>
                <Button type='link' style={{padding: '10px'}}onClick={this.onClick}>{this.state.isUserSubscribed ? this.props.textOverrides.unsubscriptionButtonlabel || 'unsubscribe' : this.props.textOverrides.subscribeButtonLabel || 'subscribe'}</Button>
            </Fragment>
        );
    }
}

SubscriptionButton.propTypes = {
    ensureAuthorized: PropTypes.func.isRequired,
    returningFromAuth: PropTypes.bool,
    accessToken: PropTypes.string.isRequired,
    environment: PropTypes.string,
    textOverrides: PropTypes.shape({
        unsubscriptionButtonlabel: PropTypes.string,
        subscribeButtonLabel: PropTypes.string,
    }),
    resourceType: PropTypes.string.isRequired,
    resourceUrl: PropTypes.string.isRequired,
    subscriptionToAdd: PropTypes.object.isRequired,
    resourceFilter: PropTypes.func,
};

SubscriptionButton.defaultProps = {
    locale: 'en',
    environment: 'prod'
};

export default withNotificationsHubAuthFlow(SubscriptionButton);
